import axiosInstance from "@/boot/axios";

class AuthRepository {
    constructor() {
        this.path = "/v1/auth/";
    }

    async generateToken(code) {
        const response = await axiosInstance.get(`${this.path}generateToken`, {
            headers: {
                code: code,
            },
        });
        return response.data;
    }

    async loginWithToken() {
        const response = await axiosInstance.get(`${this.path}login`);
        return response.data;
    }
}

export default new AuthRepository();
